'use client'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import { AppVariant } from '@common/enums'

import { BaseMobileMenu } from '../../BaseMobileMenu'
import type { MobileMenuShellProps } from '../../mobileMenuShell.types'

export function GatewayMobileMenu(props: MobileMenuShellProps) {
  return (
    <div data-testid={MOBILE_MENU_TEST_IDS.gatewayMenu} style={{ display: 'contents' }}>
      <BaseMobileMenu {...props} appVariant={AppVariant.GATEWAY} />
    </div>
  )
}
